import { render, staticRenderFns } from "./ModalSyncServiceLocal.vue?vue&type=template&id=18b0d4dc&scoped=true"
import script from "./ModalSyncServiceLocal.vue?vue&type=script&lang=js"
export * from "./ModalSyncServiceLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0d4dc",
  null
  
)

export default component.exports